import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";
import ModalCreateBillingParty from "../createShipmentComponent/modalCreateBillingParty";

const BillingPartyWithCreate = ({
  field: { name },
  form: { setFieldValue },
  setBillingBranch,
  ...props
}) => {
  const [billingParty, setBillingParty] = useState([]);
  const [isloading, setisloading] = useState(false);
  let [addedBillingParty, setAddedBillingParty] = useState(false);
  let [Txt, setTxt] =useState("");

  useEffect(() => {
    console.log("billingpartywithcreate-dropdown",billingParty);
  }, [addedBillingParty]);

  let handleSearch = (e, data) => {
    // if (data.searchQuery.length >= 1) {
      setisloading(true);
      let searchTerm = data.searchQuery;
      setTxt(data.searchQuery);
      setFieldValue(name, data.value);
      ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party`,
      }).then((result) => {
        console.log("Result : ", result.data.resultSet);
        handleBillingPartyBranch(result.data.resultSet)
        //setBillingParty(result.data.resultSet);
        setisloading(false);
      });
    // }
  };

  let handleBillingPartyBranch = (billingPartyList) => {
    let temparray = localStorage.getItem("billingpartIds");

    if (temparray != "") {
      let temp = temparray.split(",");

      let tempa = [];
      for (let index = 0; index < billingPartyList.length; index++) {
        for (let indexj = 0; indexj < temp.length; indexj++) {
          console.log(billingPartyList[index].billingPartyId == +temp[indexj])

          if (billingPartyList[index].billingPartyId == +temp[indexj]) {
            tempa.push(billingPartyList[index]);
          }
        }
      }
      setBillingParty(tempa);
    } else {
      setBillingParty(billingPartyList);
    }
    console.log(billingPartyList)
  }

  let billingPartyNames = [];
  if (billingParty.length > 0) {
    const filterdBillers = billingParty.filter(obj => {return obj.billingPartyName.toLowerCase().startsWith(Txt)})
    console.log("filterdBillers",filterdBillers);
    filterdBillers.map((object, index) => {
      let temp = {};
      temp.key = object.billingPartyId;
      temp.text = `${object.billingPartyName} (${object.billingPartyCode})`;
      temp.value = object.billingPartyId;
      return (billingPartyNames[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    if (data.value){
      setFieldValue(name, data.value);
      console.log("mydataa",data);
      // setBillingBranch(data.value)
    }      
    else{
      setFieldValue(name, null);
    }
      

    if (props?.placeholderName) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.placeholderName, selected[0]?.text);
    }
  };

  const setAddedBillingPartyFetch = () => {
    setAddedBillingParty(!addedBillingParty);
  };

  let OptionsList = billingPartyNames.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);
  return (
    <div className="display-flex-center width-100cent">
      <div className="billing-party_dropdown">
        <Dropdown
          selection
          search
          clearable
          loading={isloading ? true : false}
          style={{ width: "100%" }}
          onChange={ (value, data) => {handleChange(value, data); setBillingBranch(data.value)}}
          placeholder={props.placeholder}
          // search
          //onChange={(value, data) => {localStorage.setItem('billingpartbranchIds', data.value);setFieldValue(name, data.value);setBillingBranch(data.value)}}
          options={OptionsList}
          onSearchChange={handleSearch}
          noResultsMessage="Search for Result"
          {...props}
        />
      </div>
      <div className="create-modal-master">
        <ModalCreateBillingParty reFetchConsignee={setAddedBillingPartyFetch} />
      </div>
    </div>
  );
};

export default BillingPartyWithCreate;
